/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LocationResult } from '../models/LocationResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LocationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns LocationResult OK
     * @throws ApiError
     */
    public getLocationBySerial({
        serial,
        start,
        end,
    }: {
        serial: string,
        start?: string,
        end?: string,
    }): CancelablePromise<LocationResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/location/serial/{serial}',
            query: {
                'serial': serial,
                'start': start,
                'end': end,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns LocationResult OK
     * @throws ApiError
     */
    public getLocationByImei({
        imei,
        start,
        end,
    }: {
        imei: string,
        start?: string,
        end?: string,
    }): CancelablePromise<LocationResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/location/imei/{imei}',
            query: {
                'imei': imei,
                'start': start,
                'end': end,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
